@if (loading()) {
  <mbs-loader></mbs-loader>
} @else {
  <mbs-card-group>
    <div>
      <mbs-input-label
        [boldLabel]="true"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.authenticationType' | i18next"></mbs-input-label>
      <div class="text-base">{{ 'storages:addStorageAccountWizard.inputCredentialsStep.authenticationTypeOauth' | i18next }}</div>
    </div>
  </mbs-card-group>
  <mbs-card-group>
    <ng-container *ngTemplateOutlet="logOnTmp"></ng-container>
  </mbs-card-group>
}

<ng-template #logOnTmp>
  <div class="d-flex align-items-center justify-content-between">
    @if (form.value.email) {
      <div>
        <mbs-input-label
          [boldLabel]="true"
          [label]="'shared:common.email' | i18next"></mbs-input-label>
        <div class="text-base">{{ form.value.email }}</div>
      </div>

      <div class="mbs-form-group">
        <mbs-button
          [attr.data-e2e]="e2eLocators.logIn"
          [type]="'secondary'"
          (click)="logIn()">
          {{ 'storages:addStorageAccountWizard.inputCredentialsStep.switchAccount' | i18next }}
        </mbs-button>
      </div>
    } @else {
      <div>
        <mbs-input-label
          [boldLabel]="true"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.authorization' | i18next"></mbs-input-label>
        <div class="text-base">{{ 'storages:addStorageAccountWizard.inputCredentialsStep.loginToGoogleDrive' | i18next }}</div>
      </div>

      @if (needRevokeAccess()) {
        <mbs-button
          [attr.data-e2e]="e2eLocators.revokeAccess"
          [type]="'secondary'"
          (click)="revokeAccess()"
          >{{ 'storages:addStorageAccountWizard.inputCredentialsStep.revokeAccess' | i18next: { format: 'capitalize' } }}
        </mbs-button>
      } @else {
        <mbs-button
          [attr.data-e2e]="e2eLocators.logIn"
          [type]="'primary'"
          (click)="logIn()"
          >{{ 'storages:addStorageAccountWizard.inputCredentialsStep.login' | i18next: { format: 'capitalize' } }}
        </mbs-button>
      }
    }
  </div>
</ng-template>
